
import LayoutBarista from "../../../layout/layout_barista";
import Ordering from "./components/odering_page";

export function BaristaOrdering() {
  return (
    <>
      <LayoutBarista>
        <Ordering />
      </LayoutBarista>
    </>
  );
}
